module.exports = __webpack_public_path__ + "static/light_text-94b4ee48afb73f73232eaa595baf04cb.svg";